<template>
    <div class="body">
        <!--conter - 开始-->
        <div class="w1195">
            <!--导航-->
            <mianbao :work="work" v-if="work !=null"/>
            <!--选择商品-->
            <selectgoods :work="work" v-if="work !=null"/>
            <!--课程介绍 课程目录 - 开始-->
            <Information :work="work" v-if="work !=null"/>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Selectgoods from './selectgoods'
    import Mianbao from './mianbao'
    import Information from './information'

    export default {
        name: "Class",
        components: {
            Mianbao,
            Selectgoods,
            Information,
            axios
        },
        data() {
            return {
                work: null,
            }
        },
        methods: {
            getIdworkdata: function () {
                axios.post("/Api/getIdworks", {id: this.$route.params.id}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.work = res.data.data;
                        } else {
                            //操作失败
                        }

                    } else {
                        //操作失败
                    }
                });

            },
        },
        mounted: function () {
            if (this.$route.params.id == null) {
                this.$router.push({
                    name: 'Main',
                });
            } else {
                this.getIdworkdata();
            }
        },

    }
</script>
<style>
    .body {
        background: #f3f4f6;
        width: 100%;
        height: 100%;
    }

    .w1195 {

        width: 1195px;
        margin: auto;
    }
</style>